import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'leap-product-card-skeleton',
  templateUrl: './product-card-skeleton.component.html',
  styleUrls: ['./product-card-skeleton.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductCardSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
